import type { FC, ReactElement } from "react"

import eq from "lodash-es/eq"
import map from "lodash-es/map"
import range from "lodash-es/range"

import { buildCssClassName } from "@/3514/utils"

import { ESessionsCounterColor as EColor } from "./sessions-counter.types"

type _TProps = { dataLength: number; maxLinesCount: number; color: EColor }

const colorsMap: { [C in EColor]: string } = {
    [EColor.Red]: "border-red-400",
    [EColor.Blue]: "border-blue-300"
}

const classes = {
    divider: ({ index }: { index: number }): string =>
        buildCssClassName(
            "border-[1px] rounded-[5px] h-[5px] bg-white mx-auto",
            eq(index, 0) && "w-[calc(100%-20px)]",
            eq(index, 1) && "w-[calc(100%-30px)]",
            eq(index, 2) && "w-[calc(100%-40px)]",
            eq(index, 3) && "w-[calc(100%-50px)]"
        )
}

const SessionsCounter: FC<_TProps> = ({ dataLength, maxLinesCount, color }: _TProps): ReactElement => (
    <div>
        {map(
            range(dataLength >= maxLinesCount ? maxLinesCount : dataLength - 1),
            (idx: number): ReactElement => (
                <div
                    key={`${Math.random() ** idx}`}
                    className={buildCssClassName(classes.divider({ index: idx }), { [colorsMap[color]]: color })}
                />
            )
        )}
    </div>
)

SessionsCounter.displayName = "SessionsCounter"

export { SessionsCounter }
